import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import moment from 'moment'
import React from 'react'

class Export extends React.Component {

  static contextTypes = {
    admin: PropTypes.object,
    modal: PropTypes.object
  }

  static propTypes = {
    filter: PropTypes.object,
    token: PropTypes.string,
    type: PropTypes.string,
    onSuccess: PropTypes.func
  }

  static defaultProps = {
    onSuccess: () => {}
  }

  _handleCancel = this._handleCancel.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form {...this._getForm()} />
  }

  _getForm() {
    const { filter, type } = this.props
    return {
      title: 't(Create Batch)',
      method: 'POST',
      action: `/api/admin/finance/batches/${type}`,
      successText: 'Export',
      onCancel: this._handleCancel,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            { name: 'filter', type: 'hidden', defaultValue: filter },
            { label: 't(Date)', name: 'date', type: 'datefield', required: true, defaultValue: moment().format('YYYY-MM-DD') }
          ]
        }
      ]
    }
  }

  _handleCancel() {
    this.context.modal.close()
  }

  _handleSuccess(batch) {
    const { admin } = this.context
    const { type } = this.props
    setTimeout(() => {
      window.location.href = admin.signUrl(`/api/admin/finance/batches/${type}/${batch.id}.xlsx?$page[limit]=0&download=true`)
    }, 500)
    this.props.onSuccess()
    this.context.modal.close()
  }

}

export default Export
